import {css} from "@emotion/css";
import {RaikoIcon} from "../../raikoComponents/raikoIcon/RaikoIcon";
import {RaikoIconTypes} from "../../raikoComponents/raikoIcon/RaikoIconTypes";
import React from "react";
import {
    RaikoAlert,
    raikoAlertTypes,
    RaikoGridOneColumn,
    RaikoButtonPrimary,
    showSuccessMessage, showErrorMessage, RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";
import {RaikoLabel} from "@moeindal/base-raiko-panel-components"
const ManagerRegisterResultInfo = (
    {
        password,
        username,
        alertTitle = "",
        alertDescription = [""],
        handleCloseDialog
    }
) => {


    return (
        <RaikoGridOneColumn className={css`padding: 0 .5rem .5rem .5rem;`}>
            <RaikoAlert
                type={raikoAlertTypes.info}
                title={alertTitle}
                description={alertDescription}
            />
            <div className={css`
              display: flex;
              width: 100%;
              flex-wrap: nowrap;
              justify-content: space-between;
              padding: 1rem;
              border-radius: var(--default-border-radius);
              border: 1px solid var(--header-border-bottom-color);
              align-items: center;
              gap: .5rem`}>
                <RaikoLabel text={`نام کاربری : ${username}`}/>
                <RaikoIcon
                    icon={RaikoIconTypes.icLink}
                    onClick={_ => {
                        navigator.clipboard.writeText(username)
                            .then(_ => {
                                showSuccessMessage("نام کاربری با موفقیت کپی شد.")
                            }).catch(_ => {
                            showErrorMessage("خطا در کپی لینک !")
                        })
                    }}/>
            </div>
            <div className={css`
              display: flex;
              width: 100%;
              flex-wrap: nowrap;
              justify-content: space-between;
              padding: 1rem;
              border-radius: var(--default-border-radius);
              border: 1px solid var(--header-border-bottom-color);
              align-items: center;
              gap: .5rem`}>
                <RaikoLabel text={`گذرواژه : ${password}`}/>
                <RaikoIcon
                    icon={RaikoIconTypes.icLink}
                    onClick={_ => {
                        navigator.clipboard.writeText(password)
                            .then(_ => {
                               showSuccessMessage("گذرواژه با موفقیت کپی شد.")
                            }).catch(_ => {
                           showErrorMessage("خطا در کپی لینک !")
                        })
                    }}/>
            </div>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"تایید"}
                    onClick={_ => {
                        handleCloseDialog()
                    }}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}


export default ManagerRegisterResultInfo